var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSomethingwentwrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 399.876,
    height: 214.829,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26938"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26902",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16959",
    d: "M107.607 10.259a305.77 305.77 0 0 1 5.332-.062 3.044 3.044 0 0 1 2.2.93 8.74 8.74 0 0 1 2.356 4.929 9.458 9.458 0 0 1-.155 3.007 2.979 2.979 0 0 0 2.79 3.658c1.86.062 3.72.093 5.549.155a2.94 2.94 0 0 1 1.612.527 7.514 7.514 0 0 1 1.116 11.594 2.947 2.947 0 0 1-2.17.9q-26.831-.139-53.661-.31a2.69 2.69 0 0 0-1.3.31 119.006 119.006 0 0 1-9.3 4.03c-8.866 3.41-11.5 3.193-17.67 5.58-7.936 3.1-14.508 5.642-17.98 12.09-4.154 7.719-1.457 16.492-.62 19.22a31.455 31.455 0 0 0 5.549 10.385 2.9 2.9 0 0 0 2.449 1.085h.062a4.021 4.021 0 0 0 2.108-.868 3.009 3.009 0 0 1 1.891-.682h42.873a3.055 3.055 0 0 1 2.294 1.085 8.128 8.128 0 0 1 .279 10.509 3.007 3.007 0 0 1-2.263 1.147l-7.75.186a2.942 2.942 0 0 0-2.883 3.224 10.7 10.7 0 0 1-.186 3.379 9.773 9.773 0 0 1-1.116 2.852 2.955 2.955 0 0 1-2.573 1.488H44.18a2.977 2.977 0 0 0-2.976 2.976 18.952 18.952 0 0 1-.837 5.7c-.868 2.759-2.6 5.921-8.37 10.85-6.51 5.549-13.826 9.641-21.08 13.64-4.247 2.325-7.006 3.72-8.99 7.13a14.683 14.683 0 0 0-1.922 6.758 2.982 2.982 0 0 0 2.976 3.162h67.7a2.649 2.649 0 0 1 1.457.4 8.338 8.338 0 0 1 3.877 4.871 7.882 7.882 0 0 1 .186 3.658 3 3 0 0 0 2.945 3.472h6.138a3.009 3.009 0 0 1 1.891.682 7.719 7.719 0 0 1 2.759 4.9 7.814 7.814 0 0 1-1.705 5.7 2.953 2.953 0 0 1-2.325 1.116h-33.7a2.958 2.958 0 0 0-.93 5.766c9.176 3.069 19.964 6.293 32.147 9.114 20.677 4.774 60.544 13.671 108.811 7.75 32.953-4.03 40.176-11.346 85.561-15.5 14.508-1.333 27.032-1.8 37.51-2.17 31.31-1.116 57.289-.527 75.734.31a2.345 2.345 0 0 0 .465-.031c1.488-.155 6.138-.93 7.812-4.309 1.271-2.6.155-5.487-1.24-8.99-2.232-5.611-5.115-7.471-6.2-13.33v-.031a2.958 2.958 0 0 0-2.914-2.449h-32.638a2.889 2.889 0 0 1-2.17-.961 7.984 7.984 0 0 1-2.077-6.944 7.632 7.632 0 0 1 2.449-4.185 2.954 2.954 0 0 1 1.984-.775h7.1a2.958 2.958 0 0 0 2.945-3.348 6.643 6.643 0 0 1 .4-3.472 6.768 6.768 0 0 1 3.317-3.41 2.776 2.776 0 0 1 1.3-.31h16.245a2.985 2.985 0 0 0 2.976-3.1 47.822 47.822 0 0 0-4.588-18.29 46.872 46.872 0 0 0-9.331-13.082 2.934 2.934 0 0 0-2.077-.868h-28.18a3.018 3.018 0 0 1-1.054-.186 6.715 6.715 0 0 1-3.746-3.527 6.186 6.186 0 0 1-.465-2.108 2.994 2.994 0 0 0-2.976-2.852h-35.682a3.121 3.121 0 0 1-1.209-.248 7.194 7.194 0 0 1-4.309-6.882 7.086 7.086 0 0 1 2.79-4.929 3.062 3.062 0 0 1 1.829-.651h53.445a2.958 2.958 0 0 0 2.914-2.387c1.116-5.642 1.612-13.485-1.8-21.173-2.666-6.014-8.835-14.508-36.58-23.87-23.033-7.781-30.163-5.766-63.241-12.71-19.685-4.123-17.67-4.96-46.81-11.47-22.444-5.022-33.976-7.564-49.29-8.99-28.272-2.635-42.687.465-49.29 2.17-1.55.4-3.038.837-4.464 1.271a2.968 2.968 0 0 0 .93 5.794Z",
    fill: "#f3f3f1"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26905"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26903"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16960",
    d: "M115.601 196.632a6.608 6.608 0 0 1-6.6-6.6V33.415a6.364 6.364 0 0 1 6.355-6.355h57.351a6.364 6.364 0 0 1 6.355 6.355V43.49h104.254a5.477 5.477 0 0 1 5.487 5.487v141.052a6.608 6.608 0 0 1-6.6 6.6Z",
    fill: "#7a89a0"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26904"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16961",
    d: "M172.707 27.37a6.033 6.033 0 0 1 6.045 6.045V43.8h104.564a5.186 5.186 0 0 1 5.177 5.177v141.051a6.3 6.3 0 0 1-6.293 6.293H115.6a6.3 6.3 0 0 1-6.293-6.293V33.415a6.033 6.033 0 0 1 6.045-6.045h57.35m0-.62h-57.35a6.655 6.655 0 0 0-6.665 6.665v156.613a6.919 6.919 0 0 0 6.913 6.913h166.6a6.919 6.919 0 0 0 6.913-6.913V48.977a5.808 5.808 0 0 0-5.8-5.8H179.372v-9.765a6.655 6.655 0 0 0-6.665-6.665Z",
    fill: "#8269ff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26906"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16962",
    d: "M280.742 194.772H115.914a5.054 5.054 0 0 1-5.053-5.053V59.301h175.772v129.581a5.888 5.888 0 0 1-5.891 5.89Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26907"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16963",
    d: "M162.632 109.521a.892.892 0 0 1-.651-.279l-16.43-16.12a.921.921 0 0 1 1.3-1.3l16.43 16.12a.9.9 0 0 1 0 1.3.844.844 0 0 1-.649.279Z",
    fill: "#aa92ff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26910"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26908"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16964",
    d: "M162.632 109.521a.892.892 0 0 1-.651-.279l-16.43-16.12a.921.921 0 0 1 1.3-1.3l16.43 16.12a.9.9 0 0 1 0 1.3.844.844 0 0 1-.649.279Z",
    fill: "#7a89a0"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26909"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16965",
    d: "M146.203 109.522a.844.844 0 0 1-.651-.279.926.926 0 0 1 0-1.3l16.43-16.12a.921.921 0 1 1 1.3 1.3l-16.43 16.12a.893.893 0 0 1-.649.279Z",
    fill: "#7a89a0"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26913"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26911"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16966",
    d: "M247.263 109.521a.892.892 0 0 1-.651-.279l-16.43-16.12a.921.921 0 0 1 1.3-1.3l16.43 16.12a.9.9 0 0 1 0 1.3.844.844 0 0 1-.649.279Z",
    fill: "#7a89a0"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26912"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16967",
    d: "M230.834 109.522a.845.845 0 0 1-.651-.279.926.926 0 0 1 0-1.3l16.43-16.12a.921.921 0 0 1 1.3 1.3l-16.43 16.12a.892.892 0 0 1-.649.279Z",
    fill: "#7a89a0"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26914"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16968",
    d: "M228.663 162.066a13.786 13.786 0 0 1-13.8-13.8v-17.2a141.724 141.724 0 0 1 27.59 5.58v11.625a13.786 13.786 0 0 1-13.79 13.795Z",
    fill: "#d5dbe1"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26915"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16969",
    d: "M228.759 162.066h-.248a14.636 14.636 0 0 1-6.541-1.674 15.125 15.125 0 0 1-8.06-13.268c-.031-3.1-.093-5.487-.124-7.874s-.093-4.774-.124-7.874a.913.913 0 0 1 .93-.93.933.933 0 0 1 .93.93c.031 3.1.093 5.487.124 7.874s.093 4.774.124 7.874a13.216 13.216 0 0 0 7.037 11.656 12.771 12.771 0 0 0 5.7 1.457c.341 0 .713 0 1.054-.031a13.241 13.241 0 0 0 12.245-13.33v-9.92a.93.93 0 1 1 1.86 0v9.89a15.109 15.109 0 0 1-14.012 15.19 8.4 8.4 0 0 1-.895.03Z",
    fill: "#7a89a0"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26916"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16970",
    d: "M147.286 140.987a.931.931 0 0 1-.341-1.8 142.742 142.742 0 0 1 105.153 0 .933.933 0 1 1-.682 1.736 140.822 140.822 0 0 0-103.789 0 1.316 1.316 0 0 1-.341.064Z",
    fill: "#7a89a0"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26917"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16971",
    d: "M228.352 151.372a.933.933 0 0 1-.93-.93l.155-17.205a.954.954 0 0 1 .93-.93.933.933 0 0 1 .93.93l-.124 17.205a.96.96 0 0 1-.961.93Z",
    fill: "#8269ff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26922"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26920"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26918"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16972",
    d: "M129.462 46.591a.985.985 0 0 1-.62-.248l-7.285-6.665a.922.922 0 1 1 1.24-1.364l7.285 6.665a.927.927 0 0 1 .062 1.3.879.879 0 0 1-.682.312Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26919"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16973",
    d: "M122.177 46.591a.879.879 0 0 1-.682-.31.927.927 0 0 1 .062-1.3l7.285-6.665a.922.922 0 0 1 1.24 1.364l-7.285 6.665a.84.84 0 0 1-.62.246Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26921"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16974",
    d: "M125.587 34.346a7.75 7.75 0 1 1-7.75 7.75 7.753 7.753 0 0 1 7.75-7.75m0-1.86a9.61 9.61 0 1 0 9.61 9.61 9.618 9.618 0 0 0-9.61-9.61Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26925"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26923"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16975",
    d: "M52.116 147.341a1.553 1.553 0 0 1-1.054-.4l-11.036-10.075a1.558 1.558 0 1 1 2.108-2.294l11.036 10.075a1.563 1.563 0 0 1 .093 2.2 1.5 1.5 0 0 1-1.147.494Z",
    fill: "#c3cbd7"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26924"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16976",
    d: "M41.08 147.341a1.5 1.5 0 0 1-1.147-.5 1.564 1.564 0 0 1 .093-2.2l11.036-10.075a1.558 1.558 0 1 1 2.108 2.294l-11.036 10.075a1.5 1.5 0 0 1-1.054.406Z",
    fill: "#c3cbd7"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26926"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16977",
    d: "M65.137 51.706a5.89 5.89 0 1 1-5.89 5.89 5.887 5.887 0 0 1 5.89-5.89m0-3.1a8.99 8.99 0 1 0 8.99 8.99 9 9 0 0 0-8.99-8.99Z",
    fill: "#c3cbd7"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26927"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16978",
    d: "M29.95 201.127a2.945 2.945 0 1 1-2.945 2.945 2.964 2.964 0 0 1 2.945-2.945m0-3.1a6.045 6.045 0 1 0 6.045 6.045 6.033 6.033 0 0 0-6.045-6.045Z",
    fill: "#c3cbd7"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26928"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16979",
    d: "M331.428 136.027a1.55 1.55 0 1 1-1.55 1.55 1.535 1.535 0 0 1 1.55-1.55m0-1.86a3.41 3.41 0 1 0 3.41 3.41 3.4 3.4 0 0 0-3.41-3.41Z",
    fill: "#c3cbd7"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26929"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16980",
    d: "M33.826 87.357a1.55 1.55 0 1 1-1.55 1.55 1.535 1.535 0 0 1 1.55-1.55m0-1.86a3.41 3.41 0 1 0 3.41 3.41 3.4 3.4 0 0 0-3.41-3.41Z",
    fill: "#c3cbd7"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26930"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16981",
    d: "M308.953 83.326a3.255 3.255 0 1 1-3.255 3.255 3.254 3.254 0 0 1 3.255-3.255m0-3.1a6.355 6.355 0 1 0 6.355 6.355 6.364 6.364 0 0 0-6.355-6.355Z",
    fill: "#c3cbd7"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26933"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26931"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16982",
    d: "M343.891 63.734a2.779 2.779 0 0 1-2.79-2.79v-19.1a2.79 2.79 0 0 1 5.58 0v19.1a2.779 2.779 0 0 1-2.79 2.79Z",
    fill: "#c3cbd7"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26932"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16983",
    d: "M353.439 54.186h-19.1a2.79 2.79 0 1 1 0-5.58h19.1a2.79 2.79 0 1 1 0 5.58Z",
    fill: "#c3cbd7"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26936"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26934"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16984",
    d: "M345.875 214.828a1.945 1.945 0 0 1-.589-.093 1.691 1.691 0 0 1-1.023-2.17l3.906-10.819a1.7 1.7 0 1 1 3.193 1.147l-3.906 10.819a1.655 1.655 0 0 1-1.581 1.116Z",
    fill: "#c3cbd7"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26935"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16985",
    d: "M353.222 211.388a1.946 1.946 0 0 1-.589-.093l-10.82-3.906a1.691 1.691 0 0 1-1.023-2.17 1.717 1.717 0 0 1 2.17-1.023l10.819 3.906a1.691 1.691 0 0 1 1.023 2.17 1.639 1.639 0 0 1-1.58 1.116Z",
    fill: "#c3cbd7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingwentwrong);
export default __webpack_public_path__ + "static/media/somethingwentwrong.a76417c2b33a9c4e4eaf1ee5421d303f.svg";
export { ForwardRef as ReactComponent };